module.exports = __webpack_public_path__ + "assets_1789874507493/img/pic_8.bc65c1d3.png";